import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mail, Phone } from "lucide-react";

export default function StaffContacts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/contacts").then(r => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="staff-contacts" className="space-y-6">
      <div>
        <div className="overline text-[var(--brand-primary)]">Directorio</div>
        <h2 className="font-serif-cg text-3xl md:text-4xl tracking-tight mt-2">Contactos importantes</h2>
      </div>

      {loading ? (
        <p className="text-[var(--brand-muted)]">Cargando...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((c, idx) => (
            <article key={c.id} data-testid={`contact-${idx}`} className="card-cg p-5">
              <div className="overline text-[var(--brand-primary)]">{c.committee}</div>
              <h3 className="font-serif-cg text-xl mt-2">{c.name}</h3>
              <p className="text-sm text-[var(--brand-muted)]">{c.role}</p>
              <div className="hairline my-3" />
              <a href={`tel:${c.phone}`} className="flex items-center gap-2 text-sm py-1 link-underline">
                <Phone size={14} className="text-[var(--brand-primary)]" /> {c.phone}
              </a>
              <a href={`mailto:${c.email}`} className="flex items-center gap-2 text-sm py-1 link-underline">
                <Mail size={14} className="text-[var(--brand-primary)]" /> {c.email}
              </a>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
